import { BodySize } from './constants';

export function hasBodySize(size: BodySize): boolean {
	return Object.values(BodySize).includes(size);
}
